module.exports = __webpack_public_path__ + "static/img/product01-5.a41e2bf3.png";